import { FeesRepo } from '@services/fees.repo';
import * as moment from 'moment';
import * as _ from 'lodash';
import { FeeCalculationType } from '@common/enums/FeeCalculation'
import { extractErrorMessage } from '@common/utils/errorUtils';

class InstructionSheetController {
  // Shared state from parent (bindings)
  public fromDate: Date;
  public toDate: Date;
  public displayMCB: boolean;
  public reloadInstructionSheets: boolean;

  // Local state
  public feeInstructions;
  public isLoading = false;

  /** @ngInject */
  constructor(
    private notifyjs,
    private $scope: angular.IScope,
    private feesRepo: FeesRepo,
    private $window: angular.IWindowService
  ) {}

  $onChanges(changes: any) {
    if (changes.reloadInstructionSheets && !changes.reloadInstructionSheets.isFirstChange()) {
      this.getFeeInstructionSheets();
    }
  }

  refreshData = () => {
    this.getFeeInstructionSheets();
  };

  getFeeInstructionSheets = () => {
    if (!this.fromDate || !this.toDate) {
      return;
    }

    let feeCalculationType = this.displayMCB ? FeeCalculationType.MCB : FeeCalculationType.EDR;
    this.isLoading = true;
    let fromDate = moment(this.fromDate).startOf('month').format('YYYY-MM-DD');
    let toDate = moment(this.toDate).endOf('month').format('YYYY-MM-DD');
    this.feesRepo.getFeeInstructionSheets(fromDate, toDate, feeCalculationType)
      .then(res => {
        this.feeInstructions = [];
        this.feeInstructions = res.data as Array<any>;
      })
      .catch(err => {
        this.notifyjs("Could not load fee instructions")
      })
      .finally(() => this.isLoading = false)
  }




  convertToLocaleDate = (date: any) => {
    date = new Date(date)
    return moment(date).local().format('YYYY-MM-DD');
  }

  convertToLocaleDateTime = (date: any) => {
    date = new Date(date+'Z').toLocaleString()
    return moment(date).format('YYYY-MM-DD hh:mm:ss a');
  }



  downloadInstructionSheet = (sheet) => {
    this.feesRepo.downloadFeeInstruction(sheet.id)
      .then(res => {
        let instructionExcel = res.data as any;
        this.$window.open(instructionExcel.url, '_blank');

      })
      .catch(err => {
        this.notifyjs("Could not download excel " + extractErrorMessage(err))
      })

  }


}
export const instructionSheet: angular.IComponentOptions = {
  template: require('./fees.instructions.sheets.html'),
  controller: InstructionSheetController,
  bindings: {
    reloadInstructionSheets: "<",
    fromDate: "<",
    toDate: "<",
    displayMCB: "<",
  }
};



// WEBPACK FOOTER //
// ./src/app/fees/instructions/instructionSheets/fees.instructions.sheets.ts